import { CSS as AccordionCSS } from '../../components/accordion/accordion.style';
import { addStyles, DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-CSVImport',
	title: 'c-CSVImport__title',
	message: 'c-CSVImport__message',
	option: {
		container: 'c-CSVImport__option',
		textContainer: 'c-CSVImportOption__text-container',
		text: 'c-CSVImportOption__text',
		subText: 'c-CSVImportOption__subText',
		value: 'c-CSVImportOption__value',
		importing: 'c-CSVImport__importing',
		download: 'c-CSVImportOption__download',
		disabled: 'c-CSVImportOption__download--disabled',
	},

	importButton: 'c-CSVImport__button',
	isOptionComplete: 'c-CSVImportOption--is-complete',
	isOptionIconComplete: 'c-CSVImportIcon--is-complete',
	isTooManyCollections: 'c-CSVImport--too-many-collections',

	job: {
		container: 'c-CSVImport__job',
	},
	form: {
		container: 'c-CSVImport__form',
	},
	file: {
		container: 'c-CSVImport__file',
		drop: 'c-CSVImport__drop',
	},
	csv: {
		container: 'c-CSVImport__csv',
	},
	tabBar: {
		container: 'c-Tab-bar',
		tab: 'c-TabBar__tab',
		tabActive: 'c-TabBar__tab--active',
	},

	importNotifications: {
		container: 'c-ImportNotifications',
		collectionLink: 'c-ImportNotifications__collectionLink',
		collectionResult: 'c-ImportNotifications__collectionResult',
		skippedFilesList: 'c-ImportNotifications__skippedFilesList',
		importSummary: 'c-ImportNotifications__importSummary',
	},
};

addStyles({
	[CSS.container]: {
		width: '80%',
		margin: DefaultTheme.space(4),
		'box-shadow': DefaultTheme.shadow.box.dp2,
	},
	[CSS.title]: {
		padding: '0 ' + DefaultTheme.space(6),
		height: DefaultTheme.space(12),
		'line-height': DefaultTheme.space(12),
		display: 'flex',
		'& h6': {
			margin: 0,
			'line-height': DefaultTheme.space(12),
		},
	},
	[CSS.message]: {
		padding: DefaultTheme.space(6),
	},
	[CSS.option.container]: {
		padding: DefaultTheme.space(4),
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'space-between',
	},
	[CSS.option.importing + ' .c-Spinner']: {
		'margin-right': DefaultTheme.space(4),
	},
	[CSS.option.value]: {
		display: 'flex',
		'align-items': 'center',
		height: DefaultTheme.space(10),
		width: '300px',
	},
	[CSS.option.textContainer]: {
		'font-size': '120%',

		display: 'flex',
		flex: '1',
		'align-items': 'center',
		padding: DefaultTheme.space(1),
		'& i': {
			'padding-right': '16px',
		},
	},
	[CSS.option.text]: {
		paddingRight: DefaultTheme.space(2),
		'&:only-child': {
			paddingLeft: `calc(${DefaultTheme.space(4)} + 24px)`,
		},
	},
	[CSS.option.subText]: {
		paddingRight: DefaultTheme.space(2),
		paddingLeft: `calc(${DefaultTheme.space(4)} + 24px)`,
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.option.download]: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'font-size': '120%',
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(4)}`,
		boxSizing: 'border-box',
		border: '1px solid black',

		color: 'black',

		cursor: 'pointer',

		'&:hover': {
			background: DefaultTheme.background.lightGrey,
			borderColor: DefaultTheme.color.accent,
			color: DefaultTheme.color.accent,
		},
		'&:active': {
			background: DefaultTheme.background.active,
		},

		'& i': {
			'padding-right': '4px',
		},
	},
	[CSS.option.disabled]: {
		pointerEvents: 'none',
		opacity: 0.5,
	},
	[CSS.isOptionComplete]: {
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.isOptionIconComplete]: {
		color: 'green',
	},
	[CSS.isTooManyCollections]: {
		padding: DefaultTheme.space(4),
		'font-weight': 'bold',
	},
	[CSS.csv.container]: {
		padding: DefaultTheme.space(4),
		'align-items': 'center',
		'justify-content': 'space-between',
	},
	[CSS.file.drop]: {
		height: '56px',
		width: '300px',
	},
	[CSS.importButton]: {
		padding: DefaultTheme.space(4),
		'text-align': 'right',
	},
	[CSS.tabBar.container]: {
		padding: DefaultTheme.space(4),
		display: 'flex',
	},
	[CSS.tabBar.tab]: {
		position: 'relative',
		padding: `${DefaultTheme.space(4)} ${DefaultTheme.space(6)}`,
		'font-size': '120%',
		cursor: 'pointer',
		transition: '0.1s',
		overflow: 'hidden',
		userSelect: 'none',

		'&:after': {
			content: '""',
			position: 'absolute',
			bottom: '0',
			left: '0',
			display: 'block',
			width: '100%',
			height: '0px',
			background: DefaultTheme.color.accent,
			transition: '0.1s',
		},
		'&:hover': {
			background: DefaultTheme.background.lightGrey,
		},
		'&:active': {
			background: DefaultTheme.background.active,
		},
		[`&:not(.${CSS.tabBar.tabActive}):hover:after`]: {
			height: '2px',
		},
	},
	[CSS.tabBar.tabActive]: {
		'&:after': {
			height: '4px',
		},
	},
	[CSS.importNotifications.container]: {
		display: 'flex',
		'flex-direction': 'column',
		gap: DefaultTheme.space(2),
		'min-width': '650px',
	},
	[`${CSS.importNotifications.container} .${AccordionCSS.body}`]: {
		'& > div > div': {
			display: 'flex',
			'align-items': 'center',
		},
		'& > div > div > .material-icons': {
			'margin-right': '4px',
		},
		'& td': {
			border: '1px solid #ccc',
			padding: '6px 8px',
		},
		'& th': {
			border: '1px solid #ccc',
			padding: '6px 8px',
			background: '#f5f5f5',
			'font-weight': 'bold',
			'text-align': 'left',
		},
		'& tr': {
			border: '1px solid #ccc',
		},
		'& table': {
			width: '100%',
			border: '1px solid #ccc',
			'border-collapse': 'collapse',
			'margin-top': DefaultTheme.space(2),
		},
	},
	[CSS.importNotifications.importSummary]: {
		'font-weight': 'bold',
		'padding-bottom': DefaultTheme.space(2),
	},
	[CSS.importNotifications.collectionLink]: {
		'margin-right': '4px',
	},
	[CSS.importNotifications.skippedFilesList]: {
		margin: 0,
		'padding-left': DefaultTheme.space(5),
	},
});
